export default {
  type: "Feature",
  properties: {
    name: "Ховд",
    location: [47.03807908170818, 92.6610732399697],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [91.04844331741333, 46.719850466635805],
        [91.05352878570557, 46.7231529074099],
        [91.10275268554688, 46.71209003858017],
        [91.16386413574219, 46.68995749641134],
        [91.27304077148438, 46.66263249079177],
        [91.31973266601562, 46.60133659339023],
        [91.34994506835938, 46.55886030311719],
        [91.43096923828124, 46.54280504427768],
        [91.50238037109375, 46.56735822330717],
        [91.56829833984375, 46.613601326659726],
        [91.77841186523438, 46.616431255357995],
        [91.83677673339842, 46.62256226021187],
        [91.87179565429688, 46.63717954716511],
        [91.92672729492188, 46.702673044474004],
        [91.86492919921875, 46.72950714675161],
        [91.76055908203125, 46.76926297371478],
        [91.70665740966797, 46.79629898997745],
        [91.63524627685547, 46.826845094695884],
        [91.5707015991211, 46.86605963365364],
        [91.51542663574219, 46.89234316754865],
        [91.49311065673828, 46.90688744465985],
        [91.45465850830077, 46.94369966371151],
        [91.44332885742188, 46.971350795196734],
        [91.44092559814453, 47.00835281693705],
        [91.44882202148438, 47.06310621972502],
        [91.46358489990234, 47.10565336099383],
        [91.46873474121094, 47.13041790553795],
        [91.46427154541016, 47.159139675920336],
        [91.44847869873047, 47.20697480997098],
        [91.40041351318358, 47.22749569440931],
        [91.35612487792969, 47.258961160390896],
        [91.28986358642578, 47.33510005753562],
        [91.2366485595703, 47.36905939398393],
        [91.2527847290039, 47.45989767565368],
        [91.26205444335938, 47.49493650511712],
        [91.26136779785156, 47.528561072779034],
        [91.25656127929688, 47.545712894408624],
        [91.21742248535156, 47.59273570820418],
        [91.1916732788086, 47.61287541946062],
        [91.17382049560545, 47.645036570200254],
        [91.1703872680664, 47.661225340769356],
        [91.17107391357422, 47.72246594225631],
        [91.1367416381836, 47.731010795533955],
        [91.11648559570312, 47.73955424703249],
        [91.0982894897461, 47.75109722475338],
        [91.08455657958984, 47.76494541923992],
        [91.07460021972656, 47.78155838741233],
        [91.05949401855469, 47.83989242396357],
        [90.98533630371094, 47.97521412341618],
        [90.94757080078124, 48.02414643492423],
        [90.9286880493164, 48.0406764393366],
        [90.88680267333984, 48.068444087227796],
        [90.86585998535156, 48.09527955700514],
        [90.85487365722655, 48.11889235864144],
        [90.83427429199219, 48.22375773926874],
        [90.82054138183594, 48.272225451004324],
        [90.81745147705078, 48.29895447218437],
        [90.82019805908203, 48.34871995385989],
        [90.83427429199219, 48.412795581099964],
        [90.83324432373047, 48.453114986767304],
        [90.81710815429688, 48.525018116559266],
        [90.81024169921875, 48.54525091510785],
        [90.79891204833984, 48.56229474861628],
        [90.77934265136719, 48.58432959223574],
        [90.71891784667969, 48.63880752291323],
        [90.73917388916016, 48.65241782207755],
        [90.81436157226562, 48.6478814638068],
        [90.83427429199219, 48.64470577018957],
        [90.88233947753906, 48.633135480842654],
        [90.90808868408203, 48.62950503924253],
        [90.94310760498047, 48.630412674131264],
        [90.96576690673828, 48.63404305042837],
        [91.04679107666016, 48.65967514645313],
        [91.10172271728516, 48.68257422428195],
        [91.14086151123047, 48.70342373350562],
        [91.16901397705078, 48.710447166883384],
        [91.19510650634766, 48.71384525048727],
        [91.2205123901367, 48.7127125814524],
        [91.26033782958983, 48.702517412636006],
        [91.33827209472655, 48.671862832349746],
        [91.33827209472655, 48.671855747342164],
        [91.45156860351562, 48.738983936650705],
        [91.549072265625, 48.80686346108517],
        [91.59576416015625, 48.8583905296204],
        [91.66305541992188, 48.915279853443806],
        [91.73171997070312, 48.943249256234296],
        [91.82647705078125, 48.96128571799032],
        [91.94183349609375, 48.96939999849952],
        [91.93634033203125, 48.935130721045326],
        [91.93359375, 48.89812957181126],
        [91.94732666015625, 48.827661462789415],
        [91.95968627929688, 48.8032455364465],
        [91.99264526367186, 48.783342285295475],
        [92.03521728515625, 48.77881771792104],
        [92.08053588867188, 48.78243740444988],
        [92.12310791015625, 48.78243740444988],
        [92.15194702148438, 48.77157756174562],
        [92.17117309570312, 48.748945343432936],
        [92.23297119140625, 48.62110864256238],
        [92.36480712890625, 48.62383195130112],
        [92.47329711914062, 48.62020084032983],
        [92.59277343749999, 48.60567378414743],
        [92.64907836914062, 48.59568400838304],
        [92.7685546875, 48.56024979174331],
        [92.8231430053711, 48.557295819191374],
        [92.86571502685545, 48.564339622814806],
        [92.88768768310547, 48.57342695234659],
        [92.91275024414061, 48.590007119230734],
        [92.94158935546875, 48.61588855676401],
        [92.96012878417969, 48.62587433642767],
        [92.97351837158203, 48.63063958030254],
        [92.99892425537108, 48.635404374196476],
        [93.0270767211914, 48.63676566123227],
        [93.05591583251953, 48.63563125791999],
        [93.08269500732422, 48.63109338958398],
        [93.12835693359375, 48.61861214713695],
        [93.15067291259766, 48.60703587322351],
        [93.16852569580078, 48.59409454371403],
        [93.19015502929688, 48.57183678756225],
        [93.22071075439453, 48.51774142617034],
        [93.25675964355469, 48.47610776896956],
        [93.27323913574219, 48.463815894066066],
        [93.3120346069336, 48.447649823664435],
        [93.3343505859375, 48.43990650238739],
        [93.37177276611328, 48.43284538647477],
        [93.42950463294981, 48.42429528259198],
        [93.42950999736786, 48.42429528259198],
        [93.45245361328125, 48.39615735440508],
        [93.47305297851562, 48.377689389945736],
        [93.4830093383789, 48.36537369040198],
        [93.4881591796875, 48.350773448467265],
        [93.4891891479492, 48.32429984442754],
        [93.48335266113281, 48.3005532009148],
        [93.43666076660156, 48.19950665733754],
        [93.3892822265625, 48.10926514749487],
        [93.30413818359375, 48.056053763981225],
        [93.240966796875, 48.00094957553023],
        [93.18225860595703, 47.96601978044179],
        [93.2684326171875, 47.864773955792245],
        [93.39340209960938, 47.77348330190447],
        [93.51150512695312, 47.7097615426664],
        [93.61443758010864, 47.65159940883532],
        [93.61441612243652, 47.65161386351681],
        [93.53948593139648, 47.557472555826074],
        [93.63990783691406, 47.514418190183974],
        [93.70719909667969, 47.47127045275428],
        [93.74908447265625, 47.428087261714275],
        [93.77311706542969, 47.38998234483188],
        [93.8788604736328, 47.33603074146188],
        [93.9935302734375, 47.31648293428332],
        [94.04296874999999, 47.28295557691231],
        [94.06494140625, 47.2270293988673],
        [94.12261962890625, 47.10191431533551],
        [94.20501708984375, 46.99524110694596],
        [94.27093505859375, 46.89210855010365],
        [94.33959960937499, 46.832012719114765],
        [94.405517578125, 46.800059446787316],
        [94.251708984375, 46.741742832123364],
        [94.12261962890625, 46.72291755083757],
        [93.98529052734375, 46.72291755083757],
        [93.91937255859375, 46.70031853924921],
        [93.8287353515625, 46.621147474556096],
        [93.78204345703125, 46.579630646972596],
        [93.76556396484375, 46.549416608392264],
        [93.68865966796875, 46.59850587595948],
        [93.6199951171875, 46.62492015414768],
        [93.52111816406249, 46.632464724627475],
        [93.55133056640625, 46.5607488448596],
        [93.61175537109375, 46.479482189368646],
        [93.6309814453125, 46.41892578708076],
        [93.61724853515625, 46.36777895261494],
        [93.5430908203125, 46.24824991289166],
        [93.46618652343749, 46.17222297845542],
        [93.40576171875, 46.044642082970135],
        [93.37554931640625, 45.891919851282076],
        [93.24371337890625, 45.82114340079471],
        [93.12286376953124, 45.77135470445036],
        [93.0816650390625, 45.72535642341016],
        [93.0816650390625, 45.66780526567164],
        [93.10638427734375, 45.61403741135093],
        [93.13934326171875, 45.54867850352087],
        [93.153076171875, 45.50057194157226],
        [93.15032958984375, 45.24201954967743],
        [93.21195602416992, 45.00498626838617],
        [93.21740627288818, 44.99686891680278],
        [93.21736335754395, 44.9969144378685],
        [93.13385009765625, 45.01336034905033],
        [93.043212890625, 45.017243565102596],
        [92.98278808593749, 45.00170912094224],
        [92.93060302734375, 45.021126517829614],
        [92.8839111328125, 45.0502402697946],
        [92.78228759765625, 45.052180659942316],
        [92.6422119140625, 45.017243565102596],
        [92.54608154296874, 45.023067895446175],
        [92.48565673828125, 44.999767019181306],
        [92.4114990234375, 45.01918507438176],
        [92.3236083984375, 45.009476869672895],
        [92.3016357421875, 45.02889163330817],
        [92.2357177734375, 45.01918507438176],
        [92.10113525390625, 45.07739974122637],
        [92.05718994140625, 45.08515722028692],
        [91.790771484375, 45.08127861241874],
        [91.68365478515625, 45.058001435398296],
        [91.6204833984375, 45.06964120886863],
        [91.57379150390625, 45.08127861241874],
        [91.5545654296875, 45.06770141120143],
        [91.49139404296875, 45.10066901851988],
        [91.4501953125, 45.1510532655634],
        [91.3897705078125, 45.11423838585088],
        [91.32659912109375, 45.125866704733575],
        [91.241455078125, 45.13361760070825],
        [91.18927001953124, 45.154927133618465],
        [91.15631103515625, 45.20139301126898],
        [91.11785888671875, 45.213003555993964],
        [91.04644775390625, 45.20719857986464],
        [90.99426269531249, 45.21493841637806],
        [90.8843994140625, 45.18784438050534],
        [90.86242675781249, 45.19945769007778],
        [90.89263916015625, 45.24588722974015],
        [90.8734130859375, 45.282617057517406],
        [90.8294677734375, 45.29421101337773],
        [90.7965087890625, 45.28648197278284],
        [90.81024169921875, 45.325116643332684],
        [90.76629638671875, 45.40037851725538],
        [90.77178955078125, 45.42929873257377],
        [90.67291259765625, 45.481317798141255],
        [90.66192626953125, 45.54098421805075],
        [90.71136474609375, 45.729191061299936],
        [90.84320068359375, 45.89383147810292],
        [91.021728515625, 46.02366774426006],
        [91.02447509765625, 46.06370275591751],
        [91.0052490234375, 46.0770413127077],
        [91.01074218749999, 46.12274903582433],
        [90.977783203125, 46.162712212065664],
        [90.94482421875, 46.21785176740299],
        [90.9503173828125, 46.2330529447983],
        [90.89263916015625, 46.3127900695348],
        [90.9722900390625, 46.36967413462374],
        [91.0052490234375, 46.45678142812658],
        [91.07391357421875, 46.5607488448596],
        [91.065673828125, 46.5739667965278],
        [91.01074218749999, 46.579630646972596],
        [91.01486206054688, 46.61029955626745],
        [91.04816436767578, 46.71997550705079],
        [91.04844331741333, 46.719850466635805],
      ],
    ],
  },
};
